import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { translate } from '../Services/translation';
import SmdDialog from './SmdDialog';
import BuyMultipleButton from './BuyMultipleButton';

export default function QuantityCheckDialog({
  onChange,
  url,
  onClose,
  showDialog,
  clearFavouriteList
}) {
  const dialogRef = useRef(null);
  const [dialogData, setDialogData] = useState({ show: false, url: '', onChange: null });
  const [href, setHref] = useState(null);

  const quantityFields = useSelector((state) => {
    return state.quantityInput.quantityFields;
  });

  const quantityFieldsWithValues = Object.values(quantityFields).filter(
    (item) => item.value > 0 && item.includeInMultiPurchase
  );
  window.openQuantityCheckDialog = (url, show, onChange = null) => {
    setDialogData({ show, url, onChange });
  };
  useEffect(() => {
    if ((showDialog || dialogData.show) && quantityFieldsWithValues.length > 0) {
      dialogRef.current.showModal();
    }
    setHref(dialogData.url);
  }, [showDialog, dialogData]);

  useEffect(() => {
    if (quantityFieldsWithValues.length === 0) {
        if (href) {
            window.location.href = href;
        }
        if (dialogData.onChange) {
            dialogData.onChange();
        }
    } 
  }, [href, dialogData]);

  const clickContinue = (url) => {
    window.QuantityCheckDialogContinue = true;
    if (onChange) {
      onChange();
      }
    if (dialogData.onChange) {
        dialogData.onChange();
    }
    if (url) {
      window.location.href = url;
    }
    if (href) {
      window.location.href = href;
    }
  };

  const handleBuyComplete = (success) => {
    if (success) {
      setBuyCompleted(true);
    }
  };

  return (
    <div className="quantity-check-dialog">
      {' '}
      <SmdDialog
        ref={dialogRef}
        query={translate('code.quantitydialog.input.reminder')}
      >
        <div className="row quantity-check-dialog__container">
          <div className="small-12 columns cart__dialog--button-container">
            <BuyMultipleButton
              mode={screen.width >= 768 ? '' : 'mobile'}
              href={href}
              clearFavouriteList={clearFavouriteList}
            />
          </div>
          <div className="small-12 columns cart__dialog--button-container">
            <button
              className="button button--cta button__secondary"
              onClick={() => {
                clickContinue(url);
                dialogRef.current.close();
              }}
            >
              {translate('code.quantitydialog.button.continue')}
            </button>
          </div>
        </div>
      </SmdDialog>
    </div>
  );
}
